export const APP_HEADER_SET_APP_HEADER_TITLE = 'APP_HEADER_SET_APP_BAR_TITLE';
